import { adminDashboard } from './dashboard';
import { adminUsers } from './users';
import { adminCommunity } from './community';
import { adminAccounts } from './accounts';
import { adminCommissions } from './commissions';
import { adminNews } from './news';

export const adminTr = {
  ...adminDashboard,
  ...adminUsers,
  ...adminCommunity,
  ...adminAccounts,
  ...adminCommissions,
  ...adminNews,
};
